// removed by extract-text-webpack-plugin
module.exports = {"boxcontainer":"src-components-presentation-icon-box-__icon-box-module___boxcontainer","box":"src-components-presentation-icon-box-__icon-box-module___box","iconContainer":"src-components-presentation-icon-box-__icon-box-module___iconContainer","label":"src-components-presentation-icon-box-__icon-box-module___label","icon":"src-components-presentation-icon-box-__icon-box-module___icon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentation/icon-box/icon-box.module.css
// module id = 78
// module chunks = 0